import { Component, ɵConsole } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, Platform } from 'ionic-angular';
import { B03D02ReportFullPage } from '../b03-d02-report-full/b03-d02-report-full';
import { Storage } from '@ionic/storage';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
import { B08PrinterPage } from '../b08-printer/b08-printer';
import crc32 from 'crc/crc32';

/**
 * Generated class for the B03ReportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface inventoryInfo{
  INVENTORY_ID: number;
  ITEM_DESC: string;
  INVENTORY_ACTIVE: string;
  TOTAL_LITER: number;
  TOTAL_QTY: string;
  TOTAL_VALUE: number;
}

interface paymentTypeInfo{
  PAYMENT_TYPE_ID: number;
  TYPE: string;
  AUTHORIZE: string;
  PAYMENT_TYPE_ACTIVE: string;
  TOTAL_PAYMENT: number;
}

interface branchInfo{
  BRANCH_ID: number;
};

interface inventoryInfo{
};

@IonicPage()
@Component({
  selector: 'page-b03-report',
  templateUrl: 'b03-report.html',
})
export class B03ReportPage {

  loading: any;
  Status: any;
  closingData1: any;
  cashSales: any;
  ccardSales: any;
  fcardSales: any;
  companyInfo: any;
  userInfo: any;
  receiptInfo: any;
  receiptInfo2: any;
  paymentInfo: any;
  paymentInfo2: any;
  thankyouInfo: any;
  // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
  s_companyInfo: any;
  s_userInfo: any;
  s_receiptInfo: any;
  s_receiptInfo2: any;
  s_paymentInfo: any;
  s_paymentInfo2: any;
  s_thankyouInfo: any;
  // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
  companyData = { COMPANY:'', LOGO:'', 
                  ADD1:'', ADD2:'', ADD3:'',
                  CONTACT_NO1:'', CONTACT_NO2:'',
                  EMAIL:'',
                }

  paymentData = { AMOUNT_TENDER:0, AMOUNT_CHANGE:'', CORP_CARD_NO:'', AUTH_NO:'',
                  DATETIME:'', PAYMENT_TYPE_ID:'',
                }
  salesData =   { SOL_DESC:'', QTY:0, UNIT_PRICE:'', DISC_PERC: '', TAX_PERC:'', TOTAL_TAX:'',
                  SOL_TOTAL:'', GRAND_SOL_TOTAL:0, INVENTORY_ID:'',
                }
  closingData = { RunNo: '', DateTime: '',
                  Payment:[this.paymentData],
                  Sales:[this.salesData],
                } 
  reportData =  { Cash:0, CCard:0, FCard: 0,
                  ShiftStart: '', ShiftEnd: '', 
                  refund:0,
                }
  userData =    { LOGIN: '', PASSWORD:'', USER_NAME:'',
                BRANCH_ID: "", BRANCH_NAME:'', GRP_ID: '', CORP_ID: null, 
                USER_ACTIVE:'YES',
                }
  userRunNoData = { USER_RUNNO:'', USER_RUNNO2:'', USER_RUNNO3:'' } // [YOW:22/07/2020:CR/MPOS/20-03]:Added
  paymentTypeArr: paymentTypeInfo[] = [];
  paymentTypeItems: paymentTypeInfo[] = [];
  refundData= [];
  errorMessage: any;
  USER_ID: any;
  invArr: inventoryInfo[] = [];
  invItems: inventoryInfo[] = [];
  count_b: any;
  count_c: any;
  count_d: any;
  sales_length: any;
  inventory_length: any;
  userId: any;
  userName: any;
  userGrpId: any;
  userBranchId:any;
  DATA_Array = [];
  paymentType_length: any;
  Grand_Total: any=0;
  tempData: any;
  inventoryData= [];
  branchData=[];
  //BRANCH
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  paymentTypeData= [];
  userRunNo: any;
  CRC: any = 0; // [YOW:22/07/2020:CR/MPOS/20-03]:Added

  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public loadingCtrl: LoadingController, public serviceapi: ServiceApiProvider,
              public alertCtrl : AlertController, public servicegvariable:ServiceGvariableProvider,
              public storage: Storage, public platform: Platform, private alertController:AlertController,
              public plt: Platform
              ) {
                
    this.userId = sessionStorage.getItem('userid');
    this.userName = sessionStorage.getItem('username');
    this.userGrpId = sessionStorage.getItem('usergroupid');
    
/*     this.errorMessage = platform.platforms(); */
    this.reportData.Cash = 0;
    this.reportData.CCard = 0;
    this.reportData.FCard = 0;

    if (this.servicegvariable.InternetConnection == 'Online'){        //when system online
      if (this.userGrpId == '1'){             //if system admin
        let tbl = ["All"];
        let column = ["All"];
        let value = ['All'];

        let tblkey = ["All"];
        let fktbl = ["All"];
        let fkkey = ["All"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        this.showLoader();
        this.serviceapi.readdata(json_data,"SETTING","1","1").then((result) => {
          
          this.Status = result["Message"];
          if (this.Status == '1'){
            let Records = result["Records"];
            
            this.companyData.COMPANY = Records[0].COMPANY;              //get company info for receipt header
            this.companyData.ADD1 = Records[0].ADD1;
            this.companyData.ADD2 = Records[0].ADD2;
            this.companyData.ADD3 = Records[0].ADD3;
            this.companyData.CONTACT_NO1 = Records[0].CONTACT_NO1;
            this.companyData.EMAIL = Records[0].EMAIL;

            this.continueRequest();
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          this.loading.dismiss();
        });
      }
      else {
        this.userBranchId = sessionStorage.getItem('userbranchid');
        let tbl = ["BRANCH"];
        let column = ["BRANCH_ID"];
        let value = [this.userBranchId];

        let tblkey = ["All"];
        let fktbl = ["All"];
        let fkkey = ["All"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        this.showLoader();
        this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
          
          this.Status = result["Message"];
          if (this.Status == '1'){
            let Records = result["Records"];
            
            this.companyData.COMPANY = Records[0].BRANCH_NAME;              //get company info for receipt header
            this.companyData.ADD1 = Records[0].ADDR1;
            this.companyData.ADD2 = Records[0].ADDR2;
            this.companyData.ADD3 = Records[0].ADDR3;
            this.companyData.CONTACT_NO1 = Records[0].CONTACT_NO;
            this.companyData.EMAIL = Records[0].EMAIL;

            this.continueRequest();
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          this.loading.dismiss();
        });
      }
    }
    else {                                                            //when system offline
      this.showLoader();
      this.storage.get('offlineBranchData').then((data) => {
        this.userBranchId = data;
        
        this.storage.get('branchData').then((data) => {
          this.branchData = data;
          if (data && data.length > 0) {
            for (let i=0; i<data.length; i++){
              let data = JSON.parse(this.branchData[i]);
              for (let i=0; i<data.length; i++){
                if (this.userBranchId == data[i].BRANCH_ID){
                  this.companyData.COMPANY = data[i].BRANCH_NAME;              //get company info for receipt header
                  this.companyData.ADD1 = data[i].ADDR1;
                  this.companyData.ADD2 = data[i].ADDR2;
                  this.companyData.ADD3 = data[i].ADDR3;
                  this.companyData.CONTACT_NO1 = data[i].CONTACT_NO;
                  this.companyData.EMAIL = data[i].EMAIL;
                }
              }
            }
            
          }
          console.log(this.companyData);
          this.USER_ID = sessionStorage.getItem('userid');   //user ID
          this.storage.get('userData').then((data) => {
            this.userData = data;
            if (data && data.length > 0) {
              for (let i=0; i<data.length; i++){
                  
                let data = JSON.parse(this.userData[i]);
                for (let i=0; i<data.length; i++){
                  if (this.USER_ID == data[i].USER_ID){

                    this.userData.USER_NAME = data[i].USER_NAME;
                    this.userData.CORP_ID = data[i].CORP_ID;
                    this.userData.BRANCH_ID = data[i].BRANCH_ID;
                    this.userData.BRANCH_NAME = data[i].BRANCH_NAME;
                    this.userData.GRP_ID = data[i].GRP_ID;
                    this.userData.USER_ACTIVE = data[i].USER_ACTIVE;
                    console.log(this.userData);

                    
                  }
                }
              }
            }
            this.storage.get('inventoryData').then((data) => {
              this.inventoryData = data;
              if (data && data.length > 0) {
                for (let i=0; i<data.length; i++){
                    
                  let data = JSON.parse(this.inventoryData[i]);
                  for (let i=0; i<data.length; i++){
                    if (this.userBranchId == data[i].BRANCH_ID){
                      this.invArr.push(data[i]);
                    }
                  }
                }
              }
              this.storage.get('paymentTypeData').then((data) => {
                this.paymentTypeData = data;
                if (data && data.length > 0) {
                  for (let i=0; i<data.length; i++){
                      
                    let data = JSON.parse(this.paymentTypeData[i]);
                    this.paymentTypeArr = data;
                  }
                  this.storage.get('closingData').then((data) => {

                    this.closingData = data;
                    this.closingData1 = data;
                    
                    this.inventory_length = this.invArr.length;
                    for (this.count_c=0; this.count_c < this.inventory_length; this.count_c++){    
                      this.invArr[this.count_c].TOTAL_LITER = 0;
                      this.invArr[this.count_c].TOTAL_VALUE = 0;
                    }
                    this.paymentType_length = this.paymentTypeArr.length;
                    for (this.count_d=0; this.count_d < this.paymentType_length; this.count_d++){     
                      this.paymentTypeArr[this.count_d].TOTAL_PAYMENT = 0;
                    }
      
                    if (data && data.length > 0) {
      
                      console.log('myArray is not empty.');
                      let data_length = this.closingData1.length;
      
                      for (let i=0; i<data_length; i++){
                
                        let data = this.closingData[i];
                        console.log(data);
      
                        let payment_length = data.Payment.length;
                        console.log(payment_length);
                        for (let a=0; a<payment_length; a++){                             //calculate data for payment
                          this.paymentType_length = this.paymentTypeArr.length;
                          for (this.count_d=0; this.count_d < this.paymentType_length; this.count_d++){                         //calculate data for payment
                            
                            //calculate each item quantity and value
                            if (data.Payment[a].PAYMENT_TYPE_ID == this.paymentTypeArr[this.count_d].PAYMENT_TYPE_ID){
                              this.paymentTypeArr[this.count_d].TOTAL_PAYMENT += +(data.Payment[a].AMOUNT_TENDER - data.Payment[a].AMOUNT_CHANGE);
                            }
                          }
                          
                        }
                
                        this.sales_length = data.Sales.length;
                        
                        for (this.count_b=0; this.count_b < this.sales_length; this.count_b++){                             //calculate data for each item
                          this.inventory_length = this.invArr.length;
                          for (this.count_c=0; this.count_c < this.inventory_length; this.count_c++){                         //calculate data for payment
                            
                            //calculate each item quantity and value
                            if (data.Sales[this.count_b].INVENTORY_ID == this.invArr[this.count_c].INVENTORY_ID){
                              this.invArr[this.count_c].TOTAL_LITER += +data.Sales[this.count_b].QTY;
                              this.invArr[this.count_c].TOTAL_VALUE += +data.Sales[this.count_b].GRAND_SOL_TOTAL;
                            }
                            this.invArr[this.count_c].TOTAL_QTY = (this.invArr[this.count_c].TOTAL_LITER).toFixed(2);
                          }
                        }
                        
                        if (i == 0){                                                      //get first SO date
                          this.reportData.ShiftStart = data.DateTime;
                        }
                        if (i == (data_length - 1)){                                      //get last SO date
                          this.reportData.ShiftEnd = data.DateTime;
                        }
                        
                      }
                      this.invItems = this.invArr;
                      this.paymentTypeItems =this.paymentTypeArr;
                      
  
                      this.paymentType_length = this.paymentTypeArr.length;
                      for (let count_temp=0; count_temp < this.paymentType_length; count_temp++){  
                        this.Grand_Total += +this.paymentTypeArr[count_temp].TOTAL_PAYMENT;
                      }
                    
                    }else{
                      this.errorMessage = 'No sales data.'
                      console.log('myArray is empty.');
                    
                    }
  
                    this.storage.get('refundData').then((data) => {
                      this.refundData = data;
                
                      if (data && data.length > 0) {
        
                        console.log('myArray is not empty.');
                        let data_length = this.refundData.length;
        
                        for (let i=0; i<data_length; i++){
                          this.reportData.refund += +this.refundData[i];
                        }
                      
                      }else{
                        this.reportData.refund = 0;
                      }
                      this.Grand_Total += -this.reportData.refund;
                      this.loading.dismiss();
                    });
                  });
                }
              });
            });
          });
        });
      });
    }

  }

  continueRequest(){
    this.USER_ID = sessionStorage.getItem('userid');   //user ID

    let tbl = ["USER"];
    let column = ["USER_ID"];
    let value = [this.USER_ID];
    
    let tblkey = ["BRANCH_ID"];
    let fktbl = ["BRANCH"];
    let fkkey = ["BRANCH_ID"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        
        let Records = result["Records"];                              //get user info to show on receipt
        
        this.userData.USER_NAME = Records[0]["USER_NAME"];
        this.userData.CORP_ID = Records[0]["CORP_ID"];
        this.userData.BRANCH_ID = Records[0]["BRANCH_ID"];
        this.userData.BRANCH_NAME = Records[0]["BRANCH_NAME"];
        this.userData.GRP_ID = Records[0]["GRP_ID"];
        this.userData.USER_ACTIVE = Records[0]["USER_ACTIVE"];

        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];                     
        
        let tblkey = ["All"];
        let fktbl = ["All"];
        let fkkey = ["All"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
          this.Status = result["Message"];
          if (this.Status == "1"){

            let Records = result["Records"];                    //get inventory info 
            
            if (this.userData.BRANCH_ID != null){
              for (let b=0; b < Records.length; b++){           //only show branch item
                if (Records[b].BRANCH_ID == this.userData.BRANCH_ID){
                  if (Records[b].INVENTORY_ACTIVE == "YES"){    //filter only active inventory
                    this.invArr.push(Records[b]);
                  }
                }
              }
            }
            else {                                              //admin
              console.log(this.userData.BRANCH_ID)
              for (let b=0; b < Records.length; b++){           //only show branch item
                if (Records[b].INVENTORY_ACTIVE == "YES"){      //filter only active inventory
                  this.invArr.push(Records[b]);
                }
              }
            }

            let tbl = ["All"];
            let column = ["All"];
            let value = ["All"];                    
            
            let tblkey = ["All"];
            let fktbl = ["All"];
            let fkkey = ["All"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");
            this.serviceapi.readdata(json_data,"PAYMENT_TYPE","1","1").then((result) => {
              this.Status = result["Message"];
              if (this.Status == "1"){

                let Records = result["Records"];  

                for (let c=0; c < Records.length; c++){           
                  if (Records[c].PAYMENT_TYPE_ACTIVE == "YES"){      //filter only active payment
                    this.paymentTypeArr.push(Records[c]);
                  }
                }

                this.storage.get('closingData').then((data) => {

                  this.closingData = data;
                  this.closingData1 = data;
                  
                  this.inventory_length = this.invArr.length;
                  for (this.count_c=0; this.count_c < this.inventory_length; this.count_c++){    
                    this.invArr[this.count_c].TOTAL_LITER = 0;
                    this.invArr[this.count_c].TOTAL_VALUE = 0;
                  }
                  this.paymentType_length = this.paymentTypeArr.length;
                  for (this.count_d=0; this.count_d < this.paymentType_length; this.count_d++){     
                    this.paymentTypeArr[this.count_d].TOTAL_PAYMENT = 0;
                  }
    
                  if (data && data.length > 0) {
    
                    console.log('myArray is not empty.');
                    let data_length = this.closingData1.length;
    
                    for (let i=0; i<data_length; i++){
              
                      let data = this.closingData[i];
                      console.log(data);
    
                      let payment_length = data.Payment.length;
                      for (let a=0; a<payment_length; a++){                             //calculate data for payment
                        this.paymentType_length = this.paymentTypeArr.length;
                        for (this.count_d=0; this.count_d < this.paymentType_length; this.count_d++){                         //calculate data for payment
                          
                          //calculate each item quantity and value
                          if (data.Payment[a].PAYMENT_TYPE_ID == this.paymentTypeArr[this.count_d].PAYMENT_TYPE_ID){
                            this.paymentTypeArr[this.count_d].TOTAL_PAYMENT += +(data.Payment[a].AMOUNT_TENDER - data.Payment[a].AMOUNT_CHANGE);
                          }
                        }
                        
                      }
              
                      this.sales_length = data.Sales.length;
                      
                      for (this.count_b=0; this.count_b < this.sales_length; this.count_b++){                             //calculate data for each item
                        this.inventory_length = this.invArr.length;
                        for (this.count_c=0; this.count_c < this.inventory_length; this.count_c++){                         //calculate data for payment
                          
                          //calculate each item quantity and value
                          if (data.Sales[this.count_b].INVENTORY_ID == this.invArr[this.count_c].INVENTORY_ID){
                            this.invArr[this.count_c].TOTAL_LITER += +data.Sales[this.count_b].QTY;
                            this.invArr[this.count_c].TOTAL_VALUE += +data.Sales[this.count_b].GRAND_SOL_TOTAL;
                          }
                          this.invArr[this.count_c].TOTAL_QTY = (this.invArr[this.count_c].TOTAL_LITER).toFixed(2);
                        }
                      }
                      
                      if (i == 0){                                                      //get first SO date
                        this.reportData.ShiftStart = data.DateTime;
                      }
                      if (i == (data_length - 1)){                                      //get last SO date
                        this.reportData.ShiftEnd = data.DateTime;
                      }
                      
                    }
                    this.invItems = this.invArr;
                    this.paymentTypeItems =this.paymentTypeArr;
                    

                    this.paymentType_length = this.paymentTypeArr.length;
                    for (let count_temp=0; count_temp < this.paymentType_length; count_temp++){  
                      this.Grand_Total += +this.paymentTypeArr[count_temp].TOTAL_PAYMENT;
                    }
                  
                  }else{
                    this.errorMessage = 'No sales data.'
                    console.log('myArray is empty.');
                  
                  }

                  this.storage.get('refundData').then((data) => {
                    this.refundData = data;
              
                    if (data && data.length > 0) {
      
                      console.log('myArray is not empty.');
                      let data_length = this.refundData.length;
      
                      for (let i=0; i<data_length; i++){
                        this.reportData.refund += +this.refundData[i];
                      }
                    
                    }else{
                      this.reportData.refund = 0;
                    }
                    this.Grand_Total += -this.reportData.refund;
                    this.loading.dismiss();
                  });
                });
    
                
                
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
              this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                this.loading.dismiss();
            });
          
            
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
            this.loading.dismiss();
        });
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B03ReportPage');
  }

  navToFullReport(){
    this.navCtrl.setRoot(B03D02ReportFullPage);
  }

  print(){
    this.printReceipt();
  }

  closing(){

    if (this.closingData1 && this.closingData1.length > 0) {
      let confirm = this.alertCtrl.create({
        title: 'Confirmation',
        message: 'Are you sure you want to close shift? System will upload closing data and clear local storage.',
        buttons: [
          {
            text: 'No',
            handler: () => {
            console.log('Disagree clicked');
            }
          }, 
          {
            text: 'Yes',
            handler: () => {
              console.log('Agree clicked');

              this.showLoader();
              let data_length = this.closingData1.length;

              if (this.closingData1.length > 0) {
                this.syncServer();
              }
                
            }
          }
        ]
      });
      confirm.present();
    }
    else {
      let addToDoAlert = this.alertController.create({
        title:"Confirmation",
        message:"No sales data",
        buttons:[
          {
            text:"OK"
          }]
      });
      addToDoAlert.present();
    }
  }

  // [YOW:22/07/2020:CR/MPOS/20-03]:Modify
  syncServer() {
    //this.DATA_Array = this.closingData;
    this.errorMessage = '';
    let value = this.SUBMIT_JSON(this.userId,this.closingData);
    
    if (this.servicegvariable.InternetConnection == 'Online') {

      this.serviceapi.possalesdata(value).then((result) => {
        this.Status = result["Message"];

        if (this.Status == "1") {
          // [YOW:22/07/2020:CR/MPOS/20-03]:Added (Get running number upload to DB)
          this.storage.get('lastLocalRunNo').then((data) => {
            this.userRunNoData.USER_RUNNO = data;

            // Get Running Number 2
            this.storage.get('lastLocalRunNo2').then((data) => {
              this.userRunNoData.USER_RUNNO2 = data;

              // Get Running Number 3
              this.storage.get('lastLocalRunNo3').then((data) => {
                this.userRunNoData.USER_RUNNO3 = data;

                this.serviceapi.updatedata('USER', 'USER_ID', this.USER_ID, this.userRunNoData).then((result) => {
                  this.Status = result["Message"];
                  
                  if (this.Status == "1") {
                    let val0 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO);
                    let val1 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO2);
                    let val2 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO3);
                    this.storage.set('lastSO_NO', val0);
                    this.storage.set('lastSO_NO2', val1);
                    this.storage.set('lastSO_NO3', val2);
  
                    this.userRunNo = 0;
                    let val3 = JSON.stringify(this.userRunNo);
                    this.storage.set('runningNoData', val3);
                    this.storage.set('runningNoData2', val3);
                    this.storage.set('runningNoData3', val3);
                    
                    this.storage.remove('closingData');   //success update, delete closing record
                    this.storage.remove('refundData');    //success update, delete refund record
                    
                    this.printReceipt();                  //print receipt when closing
                  }
                  else {
                    this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                    this.loading.dismiss();
                  }
                }, (err) => {
                    this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                    this.loading.dismiss();
                });
              });
            });
          });
        }
        else{
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
        this.loading.dismiss();
        this.errorMessage = "Slow Internet. Please Try Again"; // [CXY:17/08/2020:IL/MPOS/20-05]: Modify the error message
        if (err == 'TimeoutError: Timeout has occurred') {
          this.checkInternet();
        }
      });
    }
    else {
      this.errorMessage = "Internet Offline. Please check internet connection.";
      this.loading.dismiss();
    }
  }
  
  printReceipt() {
    let company = this.companyData.COMPANY;
    let address = this.companyData.ADD1 + ', '+ this.companyData.ADD2 + ', '+ this.companyData.ADD3;
    let contact = this.companyData.CONTACT_NO1 
    let email = this.companyData.EMAIL;
    let date = this.formatDateTime();

    if(this.plt.is("core"))
    {
      console.log(this.invArr);
      var mywindow = window.open('', 'CLOSING REPORT', 'height=400,width=600');
      mywindow.document.write('<html><head><title></title>');
      //mywindow.document.write('<link rel="stylesheet" href="main.css" type="text/css" />');
      mywindow.document.write('</head><body >');
      mywindow.document.write('<div style="max-width: 500px;margin: auto;text-align:center">');
      mywindow.document.write('<br>'+company+'<br>');
      mywindow.document.write(address+'<br>');
      mywindow.document.write(contact+'<br>');
      mywindow.document.write(email+'<br><br>');
      mywindow.document.write('<b>CLOSING REPORT</b><br>');
      mywindow.document.write('<br>' + 'User : ' + this.userData.USER_NAME + '<br>');
      mywindow.document.write('Time Start : ' + this.reportData.ShiftStart + '<br>');
      mywindow.document.write('Time End : ' + this.reportData.ShiftEnd + '<br>' + '<br>');
      
      let data_length = this.invArr.length;
      for (let i=0; i<data_length; i++ ) {
        mywindow.document.write(this.invArr[i].ITEM_DESC +' : ' + this.invArr[i].TOTAL_QTY + ' ltr & ' + ' K ' + this.invArr[i].TOTAL_VALUE + '<br>');
        
      }
      mywindow.document.write('<br>'+' '+'<br>');
      let data_length2 = this.paymentTypeArr.length;
      for (let i=0; i<data_length2; i++ ) {
        mywindow.document.write(this.paymentTypeArr[i].TYPE +' : ' + ' K ' + this.paymentTypeArr[i].TOTAL_PAYMENT + '<br>');
        
      }
      mywindow.document.write('<br>' + 'Refund  : ' + 'K '  + this.reportData.refund + '<br>');
      mywindow.document.write('<br>' + 'Grand Total  : ' + 'K '  + this.Grand_Total + '<br>');
      mywindow.document.write('<br><br><b>-------- THANK YOU --------</b><br>');
      mywindow.document.write('<div></body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus();
      mywindow.print();
      mywindow.close();
      this.navCtrl.setRoot(B03ReportPage);
    }
    else 
    {
      this.companyInfo = '';
      this.userInfo = '';
      this.receiptInfo = '';
      this.receiptInfo2 = '';
      this.paymentInfo = '';
      this.paymentInfo2 = '';
      this.thankyouInfo = '';
      // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_companyInfo = '';
      this.s_userInfo = '';
      this.s_receiptInfo = '';
      this.s_receiptInfo2 = '';
      this.s_paymentInfo = '';
      this.s_paymentInfo2 = '';
      this.s_thankyouInfo = '';
      // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added

      //header
      /*'\x1b\x61\x01'     center
      '\n'              end of line
      '\x1b\x45\x00'    Bold font OFF
      '\x1b\x45\x01'    Bold font ON
      '\x1b\x4d\x00'    Font type A //normal font
      '\x1b\x4d\x01'    Font type B //small font
      '\x1b\x4d\x02'    Font type C //big font
      '\x1b\x61\x00'    Left justification
      '\x1b\x61\x01'    Centering
      '\x1b\x61\x02'    Right justification
      */

      this.companyInfo = "\x1b\x21\x00 \x1b\x61\x01" + "\n\n"+company+"\n"+address+"\n"+'Phone: '+contact+"\n"+'Email: '+email+
                         "\n\n \x1b\x21\x20 \x1b\x45\x01"+ 'CLOSING REPORT' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_companyInfo = "\x1b\x4d\x01 \x1b\x21\x00 \x1b\x61\x01" + "\n\n"+company+"\n"+address+"\n"+'Phone: '+contact+"\n"+'Email: '+email+
                         "\n\n \x1b\x21\x20 \x1b\x45\x01"+ 'CLOSING REPORT' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";
                                          
      this.userInfo += '\x1b\x44\x00' + '\x1b\x44\x15\x20\x00';        //set tab position at 32

      this.userInfo +=   '\x1b\x61\x00' + "\n" + "   User:" + '\x09' + this.userData.USER_NAME + "\n" 
                                               + "   Time Start:" + '\x09' + this.reportData.ShiftStart + "\n" 
                                               + "   Time End:" + '\x09' + this.reportData.ShiftEnd + "\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_userInfo +=   '\x1b\x61\x00' + "\n" + "   User:" + '\x09' + this.userData.USER_NAME + "\n" 
                                               + "   Time Start:" + '\x09' + this.reportData.ShiftStart + "\n" 
                                               + "   Time End:" + '\x09' + this.reportData.ShiftEnd + "\n";

      /* this.receiptInfo  = '\x1b\x44\x00' + '\x1b\x44\x15\x20\x00';        //set tab position at 32 */
      this.receiptInfo += '\x1b\x61\x00' + "\n" + "   Item" + '\x09' + "Total Qty" + '\x09' + "Total Value" + "\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_receiptInfo += '\x1b\x61\x00' + "\n" + "   Item" + '\x09' + "Total Qty" + '\x09' + "Total Value" + "\n";
      
      let data_length = this.invArr.length;
      for (let i=0; i<data_length; i++ ) {
        if (this.receiptInfo.length < 90) {
          this.receiptInfo += "   "+ this.invArr[i].ITEM_DESC + ':' + '\x09' + this.invArr[i].TOTAL_QTY + '\x09' + 'K ' + this.invArr[i].TOTAL_VALUE + "\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_receiptInfo += "   "+ this.invArr[i].ITEM_DESC + ':' + '\x09' + this.invArr[i].TOTAL_QTY + '\x09' + 'K ' + this.invArr[i].TOTAL_VALUE + "\n";
        }  
        else {
          this.receiptInfo2 += "   "+ this.invArr[i].ITEM_DESC + ':' + '\x09' + this.invArr[i].TOTAL_QTY + '\x09' + 'K ' + this.invArr[i].TOTAL_VALUE + "\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_receiptInfo2 += "   "+ this.invArr[i].ITEM_DESC + ':' + '\x09' + this.invArr[i].TOTAL_QTY + '\x09' + 'K ' + this.invArr[i].TOTAL_VALUE + "\n";
        }
      }

      /* this.paymentInfo = '\x1b\x44\x00' + '\x1b\x44\x15\x20\x00'        //set tab position at 32
      this.paymentInfo += '\x1b\x61\x00' + "\n" + "   Payment" + '\x09' + '\x09' + "Total Value" + "\n"; */
      this.receiptInfo2 += "\n\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_receiptInfo2 += "\n\n";

      let data_length2 = this.paymentTypeArr.length;
      for (let i=0; i<data_length2; i++ ) {
        if (this.paymentInfo.length < 90) {
          this.paymentInfo +=  "   "+ this.paymentTypeArr[i].TYPE + ':' + '\x09' + '\x09' + "K " + this.paymentTypeArr[i].TOTAL_PAYMENT + "\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_paymentInfo +=  "   "+ this.paymentTypeArr[i].TYPE + ':' + '\x09' + '\x09' + "K " + this.paymentTypeArr[i].TOTAL_PAYMENT + "\n";
        }
        else {
          this.paymentInfo2 +=  "   "+ this.paymentTypeArr[i].TYPE + ':' + '\x09' + '\x09' + "K " + this.paymentTypeArr[i].TOTAL_PAYMENT + "\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_paymentInfo2 +=  "   "+ this.paymentTypeArr[i].TYPE + ':' + '\x09' + '\x09' + "K " + this.paymentTypeArr[i].TOTAL_PAYMENT + "\n";
        }
      }

      this.thankyouInfo +=  '\x1b\x61\x00' + "\n" + "   Refund:" + '\x09' + '\x09' + "K "+ this.reportData.refund + "\n";
      this.thankyouInfo +=  '\x1b\x61\x00' + "\n" + "   Grand Total:" + '\x09' + '\x09' + "K "+ this.Grand_Total + "\n";
      this.thankyouInfo +=  '\x1b\x61\x01' + "\n\n\n------ THANK YOU ------\n\n\n\n\n\n\n\n\n\n";
      // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_thankyouInfo +=  '\x1b\x61\x00' + "\n" + "   Refund:" + '\x09' + '\x09' + "K "+ this.reportData.refund + "\n";
      this.s_thankyouInfo +=  '\x1b\x61\x00' + "\n" + "   Grand Total:" + '\x09' + '\x09' + "K "+ this.Grand_Total + "\n";
      this.s_thankyouInfo +=  '\x1b\x61\x01' + "\n\n\n------ THANK YOU ------\n\n\n\n\n\n\n\n\n\n";
      // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added

      //console.log(this.receiptInfo.length, this.receiptInfo2.length)
      //console.log(this.paymentInfo.length, this.paymentInfo2.length)
      this.navCtrl.setRoot(B08PrinterPage,{
        param1: this.companyInfo,
        param2: "2",
        param3: this.userInfo,
        param4: this.receiptInfo,
        param5: this.receiptInfo2,
        param6: this.paymentInfo,
        param7: this.paymentInfo2,
        param8: this.thankyouInfo,
        // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
        param9: this.s_companyInfo,
        param10: this.s_userInfo,
        param11: this.s_receiptInfo,
        param12: this.s_receiptInfo2,
        param13: this.s_paymentInfo,
        param14: this.s_paymentInfo2,
        param15: this.s_thankyouInfo,
        // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
      });
    }
  }

  formatDateTime(){
    let date = new Date();
    let sign1 = "-";
    let sign2 = ":";
    let year:any = date.getFullYear() // 年
    let month:any = date.getMonth() + 1; // 月
    let day:any  = date.getDate(); // 日
    let hour:any = date.getHours(); // 时
    let minutes:any = date.getMinutes(); // 分
    let seconds:any = date.getSeconds() //秒

    // 给一位数数据前面加 “0”
    if ((month >= 1) && (month <= 9)) {
      month = '0' + month;
    }
    if ((day >= 0) && (day <= 9)) {
      day = '0' + day;
    }
    if ((hour >= 0) && (hour <= 9)) {
      hour = '0' + hour;
    }
    if ((minutes >= 0) && (minutes <= 9)) {
      minutes = '0' + minutes;
    }
    if ((seconds >= 0) && (seconds <= 9)) {
      seconds = '0' + seconds;
    }
    var currentdate = year + sign1 + month + sign1 + day + " " + hour + sign2 + minutes + sign2 + seconds;
    return currentdate;
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });
    this.loading.present();
  }

  SUBMIT_JSON(USERID, DATA)
  {
    let COMPILE_DATA = {
      Param:"",
      UserID:"",
      BranchID:"",  // [TCG:18/08/2020:IL/MPOS/20-04]:Added
      Total:0,
      CRC:0,
      Data:[]
    }

    COMPILE_DATA.Param = "3"; 
    COMPILE_DATA.UserID = USERID;
    COMPILE_DATA.BranchID = sessionStorage.getItem('userbranchid'); // [TCG:18/08/2020:IL/MPOS/20-04]:Added
    COMPILE_DATA.Total =  DATA.length;
    COMPILE_DATA.Data = DATA;
    
    let val = JSON.stringify(DATA);
    COMPILE_DATA.CRC = crc32(val);
    this.CRC = COMPILE_DATA.CRC;  // [YOW:22/07/2020:CR/MPOS/20-03]:Added

    return COMPILE_DATA;
  }

  // [YOW:22/07/2020:CR/MPOS/20-03]:Modified
  checkInternet() {
    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
        this.servicegvariable.InternetConnection = 'Online';

        //console.log('before');
        this.wait(7000);
        //console.log('after');

        let tbl = ["CLOSE_INFO", "CLOSE_INFO"];
        let column = ["CLOSE_CS", "CLOSE_BY"];
        let value = [this.CRC, this.USER_ID];

        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"CLOSE_INFO","1","1").then((result) => {
          this.Status = result["Message"];
  
          if (this.Status == "1") {
            // Get running number upload to DB
            this.storage.get('lastLocalRunNo').then((data) => {
                this.userRunNoData.USER_RUNNO = data;

                // Get running number 2
                this.storage.get('lastLocalRunNo2').then((data) => {
                  this.userRunNoData.USER_RUNNO2 = data;

                  // Get running number 3
                  this.storage.get('lastLocalRunNo3').then((data) => {
                    this.userRunNoData.USER_RUNNO3 = data;

                    this.serviceapi.updatedata('USER', 'USER_ID', this.USER_ID, this.userRunNoData).then((result) => {
                      this.Status = result["Message"];
                      
                      if (this.Status == "1") {
                        let val0 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO);
                        let val1 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO2);
                        let val2 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO3);
                        this.storage.set('lastSO_NO', val0);
                        this.storage.set('lastSO_NO2', val1);
                        this.storage.set('lastSO_NO3', val2);
  
                        this.userRunNo = 0;
                        let val3 = JSON.stringify(this.userRunNo);
                        this.storage.set('runningNoData', val3);
                        this.storage.set('runningNoData2', val3);
                        this.storage.set('runningNoData3', val3);
            
                        this.storage.remove('closingData');   //success update, delete closing record
                        this.storage.remove('refundData');    //success update, delete refund record
                        
                        this.printReceipt();                  //print receipt when closing
                      }
                      else {
                        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                        this.loading.dismiss();
                      }
                    }, (err) => {
                      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                      this.loading.dismiss();
                    });
                  });
                });
            });
          }
          else {
            let confirm = this.alertCtrl.create({
              title: 'Online',
              message: 'Retry close shift.',
              buttons: [
                {
                  text: 'Cancel',
                  role: 'cancel',
                  handler: data => {
                    //console.log('Cancel clicked');    //no proceed
                  }
                },
                {
                  text: 'Retry',
                  handler: () => {
                    //console.log('Agree clicked');
                    this.showLoader();
    
                    if (this.closingData1.length > 0) {
                      this.syncServer();
                    }
                  }
                }
              ],
              enableBackdropDismiss : false
            });
            confirm.present();
          }
        }, (err) => {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        });
    }, (err) => {
      //console.log("online offline")
      this.servicegvariable.InternetConnection = 'Offline';
      let confirm = this.alertCtrl.create({
        title: 'Offline',
        message: 'No internet connection. Please try again.',
        buttons: [
          {
            text: 'Confirm',
            handler: () => {
            //console.log('Agree clicked');
            }
          }
        ]
      });
      confirm.present();
    });
  }

  // [YOW:22/07/2020:CR/MPOS/20-03]:Added
  wait(ms) {
    var start = new Date().getTime();
    var end = start;
    while(end < start + ms) {
      end = new Date().getTime();
    }
  }

  // [YOW:22/07/2020:CR/MPOS/20-03]:Added
  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds) {
        let tbl = ["CLOSE_INFO", "CLOSE_INFO"];
        let column = ["CLOSE_CS", "CLOSE_BY"];
        let value = [this.CRC, this.USER_ID];

        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"CLOSE_INFO","1","1").then((result) => {
          this.Status = result["Message"];
          
          if (this.Status == "1") {
            // Get running number upload to DB
            this.storage.get('lastLocalRunNo').then((data) => {
              this.userRunNoData.USER_RUNNO = data;

              // Get running number 2
              this.storage.get('lastLocalRunNo2').then((data) => {
                this.userRunNoData.USER_RUNNO2 = data;

                // Get running number 3
                this.storage.get('lastLocalRunNo3').then((data) => {
                  this.userRunNoData.USER_RUNNO3 = data;

                  this.serviceapi.updatedata('USER', 'USER_ID', this.USER_ID, this.userRunNoData).then((result) => {
                    this.Status = result["Message"];

                    if (this.Status == "1") {
                      let val0 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO);
                      let val1 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO2);
                      let val2 = JSON.stringify(' ' + this.userRunNoData.USER_RUNNO3);
                      this.storage.set('lastSO_NO', val0);
                      this.storage.set('lastSO_NO2', val1);
                      this.storage.set('lastSO_NO3', val2);
                      
                      this.userRunNo = 0;
                      let val3 = JSON.stringify(this.userRunNo);
                      this.storage.set('runningNoData', val3);
                      this.storage.set('runningNoData2', val3);
                      this.storage.set('runningNoData3', val3);
  
                      this.storage.remove('closingData');  //success update, delete closing record
                      this.storage.remove('refundData');   //success update, delete refund record
  
                      this.printReceipt();                 //print receipt when closing
                    }
                    else {
                      this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                      this.loading.dismiss();
                    }
                  }, (err) => {
                    this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                    this.loading.dismiss();
                  });
                });
              });
            });
          }
          else {
            let confirm = this.alertCtrl.create({
              title: 'Online',
              message: 'Retry close shift.',
              buttons: [
                {
                  text: 'Cancel',
                  role: 'cancel',
                  handler: data => {
                    //console.log('Cancel clicked');    //no proceed
                  }
                },
                {
                  text: 'Retry',
                  handler: () => {
                    this.showLoader();
                    
                    if (this.closingData1.length > 0) {
                      this.syncServer();
                    }
                  }
                }
              ],
              enableBackdropDismiss : false
            });
            confirm.present();
          }
        }, (err) => {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/b03-report/b03-report.ts